
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'file360-field-label',
  templateUrl: './field-label.component.html',
  styleUrls: ['./field-label.component.scss']
})
export class FieldLabelComponent implements OnInit {

  /**
   * Label text
   */
  @Input() label: string | undefined = "";

  /**
   * Used to bound this label to a form field.
   */
  @Input() elementId: string | undefined = "";
  /**
  * Force the required indicator to display on the field label.
  * Use when data is set on the field before the field displayed.
  */
  @Input() showRequiredIndication: boolean | undefined = false;

  /**
  * Hover tip to show when mouse is hovers over the label.
  */
  @Input() hoverTip: string | undefined = "";

  /**
  * Whether the form field is read-only.
  */
  @Input() readOnly: boolean | undefined = false;

  constructor() { }

  ngOnInit() {

  }
}
